import { AlignmentType, BorderStyle, Paragraph, Table, TableCell, TableRow, TextRun, WidthType, VerticalAlign,ShadingType} from "docx";


function numberToWords(num) {
    const words = [
        "zero", "one", "two", "three", "four", "five",
        "six", "seven", "eight", "nine", "ten",
        "eleven", "twelve", "thirteen", "fourteen", "fifteen",
        "sixteen", "seventeen", "eighteen", "nineteen", "twenty",
        "twenty-one", "twenty-two", "twenty-three", "twenty-four", "twenty-five",
        "twenty-six", "twenty-seven", "twenty-eight", "twenty-nine", "thirty"
    ];

    if (num <= 30) return words[num];
    return num.toString();
}

export function observationText1(certInApplicationName, VulCount) {
    const vulCountFormatted = `${numberToWords(VulCount)} (${VulCount})`;
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 200 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `During the security testing exercise, ISECURION security testing team (hereafter referred as the ‘testing team’) ${vulCountFormatted} vulnerabilities in the External Mobile Application. The vulnerabilities are categorized as per industry framework "Common Vulnerability Scoring System v3.1" i.e. CVSS3.1 scoring. The severity rating represented below is Base Score which represents only the intrinsic characteristics of a vulnerability that are constant over time and across user environments. To enable risk-focused mitigation, these vulnerabilities are summarized in five different categories (Critical, High, Medium, Low and Information). `,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}
export const observationText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Note:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: true,
            bold: true
        }),
        new TextRun({
            text: " Business units should supplement the base CVSS score with the contextual analysis of the environment, and with attributes that may change over time by leveraging CVSS Temporal and Environmental Metrics. More appropriately, a comprehensive risk assessment system should be employed that considers more factors than simply the CVSS Base Score and represent actual risk.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: true
        }),
    ],
})

export const mappingTable = new Table({
    width: { size: 50, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 450 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity Category",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "003366" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CVSS Score Range",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "003366" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Critical",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "9.0 - 10",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "High",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "7.0 - 8.9",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Medium",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "4.0 -6.9",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Low",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.1 - 3.9",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Informational",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.0",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
    ]
})